export default "__VITE_ASSET__glgWtm3n__"